import { Modal } from "flowbite-react";
import FormDeletePayment from "../form/FormDeletePayments";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { deletePayment } from "../../../../../../../common/services/payments.api";

type Props = {
  paymentId: string;
  renterId: string;
  onClose: () => void;
}

export default function ModalDeletePayments(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const handleCloseModal = () => { props.onClose(); };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async function deletePayments(data: any) {

    const result = await deletePayment(props.paymentId, data);

    if (result.ok) {
      notifySuccess('Pagamento removido com sucesso!');
    }

    if (!result.ok) {
      notifyError(result.message as string)
    }

    return result;
  }

  return (
    <Modal
      className='relative dark:text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header>
        <div className="flex items-center justify-start gap-3">
          <span className='text-black'>
            {`Remover Pagamento`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body >
        <FormDeletePayment
          paymentId={props.paymentId}
          renterId={props.renterId}
          onClose={handleCloseModal}
          onSave={(paymentId) => paymentId}
          onSubmit={deletePayments}
          reason="Motivo da remoção"
        />

      </Modal.Body>
    </Modal>
  )

}